import * as dto from '@epicuro-next/data/baskets-dto';
import { BasketRowPrice } from 'graphql-api/baskets-api-interfaces';

/**
 * Creates price data for prepack item.
 */
export function getPricesForPrepackItem(
  prepackItem: dto.Item,
  prepackSize: number,
): BasketRowPrice {
  const info = getPricesInfo(prepackItem.prices, prepackItem.requestedQuantity);
  const normalizer = prepackSize ? 1 / prepackSize : 1;

  return {
    currency: info.currency,
    currencyRrp: info.currencyRrp,
    rrp: info.rrp * normalizer,
    wsp: info.wsp * normalizer,
    net: info.netPrice * normalizer,
    wspd: info.discountedPrice * normalizer,
    displayedwsp: info.wsp * normalizer,
    markUp: getMarkUp(info.discountedPrice, info.wsp, info.rrp),
    discountRate: getDiscountRate(info.wsp, info.discountedPrice),
  };
}

/**
 * Creates price data for size item.
 */
export function getPricesForItem(sizeItem: dto.Item): BasketRowPrice {
  const info = getPricesInfo(sizeItem.prices, sizeItem.requestedQuantity);

  return {
    currency: info.currency,
    currencyRrp: info.currencyRrp,
    rrp: info.rrp,
    wsp: info.wsp,
    net: info.netPrice,
    wspd: info.discountedPrice,
    markUp: getMarkUp(info.discountedPrice, info.wsp, info.rrp),
    discountRate: getDiscountRate(info.wsp, info.discountedPrice),
  };
}

function getMarkUp(discountedPrice: number, wsp: number, rrp: number) {
  const price = discountedPrice || wsp;
  if (!price) {
    return null;
  }

  return rrp / price;
}

function getDiscountRate(wsp?: number, discountedPrice?: number) {
  return wsp && discountedPrice ? 1 - discountedPrice / wsp : null;
}

function getPricesInfo(prices: dto.BasketItemPrice, requestedQuantity: number) {
  const wsp = prices.grossPrice?.unitPrice ?? prices.grossPrice?.price ?? null;
  const rrp =
    prices.retailPrice?.unitPrice ?? prices.retailPrice?.price ?? null;
  const netPrice = prices.netPrice?.unitPrice ?? prices.netPrice?.price ?? null;

  const discountedPrice =
    prices.discountedGrossPrice?.unitPrice ??
    prices.discountedGrossPrice?.price ??
    null;

  const currency =
    prices.grossPrice?.currency ??
    prices.retailPrice?.currency ??
    prices.discountedGrossPrice?.currency ??
    prices.netPrice?.currency ??
    null;

  const currencyRrp = prices.retailPrice?.currency ?? currency;

  return {
    currency,
    rrp,
    wsp,
    netPrice,
    discountedPrice,
    requestedQuantity,
    currencyRrp,
  };
}
